//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

//uploadConfig
const uploadConfigDataSelector = (state: RootState) => state.configuration.upload_config.data;
export const selectUploadConfigData = createSelector(uploadConfigDataSelector, (data) => data);
